module.exports = __webpack_public_path__ + "img/1 (24).5e059d1d.png";